module.exports = __webpack_public_path__ + "static/media/requestInventory.526a80e7.svg";